// src/pages/HomePage.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero';

const HomePage = () => {
  const { t } = useTranslation();

  return (
    <div className="container">
      <Hero/>

      {/* Courses Section */}
      <div className="row">
        {/* HTML Course Card */}
        <div className="col-md-4 mb-4">
          <div className="card">
            <img src="assets/html.png" className="card-img-top" alt={t('homepage.htmlAlt')} />
            <div className="card-body">
              <h5 className="card-title">{t('homepage.htmlTitle')}</h5>
              <p className="card-text">{t('homepage.htmlDescription')}</p>
              <Link to="/courses/html" className="btn btn-primary">
                {t('homepage.startLearning')}
              </Link>
            </div>
          </div>
        </div>

        {/* CSS Course Card */}
        <div className="col-md-4 mb-4">
          <div className="card">
            <img src="assets/css.png" className="card-img-top" alt={t('homepage.cssAlt')} />
            <div className="card-body">
              <h5 className="card-title">{t('homepage.cssTitle')}</h5>
              <p className="card-text">{t('homepage.cssDescription')}</p>
              <Link to="/courses/css" className="btn btn-primary">
                {t('homepage.startLearning')}
              </Link>
            </div>
          </div>
        </div>

        {/* JavaScript Course Card */}
        <div className="col-md-4 mb-4">
          <div className="card">
            <img src="assets/js.png" className="card-img-top" alt={t('homepage.jsAlt')} />
            <div className="card-body">
              <h5 className="card-title">{t('homepage.jsTitle')}</h5>
              <p className="card-text">{t('homepage.jsDescription')}</p>
              <Link to="/courses/javascript" className="btn btn-primary">
                {t('homepage.startLearning')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
